import { makeEnum } from 'services/store/utils-actions';

export const collection = 'settings';

export const types = makeEnum(
  'SET_APP_SETTINGS',
  'SET_USER_SETTINGS',
  'SET_GLOBAL_SETTINGS',
);
